import script from "./LandingPage.vue?vue&type=script&lang=ts&setup=true"
export * from "./LandingPage.vue?vue&type=script&lang=ts&setup=true"

import "./LandingPage.vue?vue&type=style&index=0&id=42ccffbc&lang=stylus&scoped=true"

import exportComponent from "/codebuild/output/src024011243/src/2022-meta-acrossthemetaverse/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-42ccffbc"]])

export default __exports__